<template>
  <v-row id="pointsOverview" class="fill-height mt-8 overview-container py-0" no-gutters>
    <v-col cols="12" :md="isMobile ? 0 : 2">
      <PointsOverviewSideMenu />
    </v-col>
    <v-col cols="12" :md="isMobile ? 12 : 10">
      <router-view></router-view>
    </v-col>
  </v-row>
</template>

<script>
  import PointsOverviewSideMenu from "./PointsOverviewSideMenu";

  export default {
    name: "PointsOverview",

    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.mobile;
      },
      points() {
        return this.$store.state.user.points;
      },
      user() {
        return this.$store.getters.userInfo;
      },
    },

    components: { PointsOverviewSideMenu },

    methods: {
      updatePointBalance(newBalance) {
        if (!this.$validator.isEmpty(newBalance)) {
          this.$sessionUser._updateUserInfo(this.$formatter.extend(this.user, { points: newBalance }));
          this.$store.commit("setUserInfo", { points: newBalance });
        }
      },

      buyPoints(points) {
        this.$http
          .post("/points", { points: { value: points } })
          .then((response) => {
            this.updatePointBalance(response.data.new_value);
          })
          .catch(() => {
            console.log("failed to purchase points");
          });
      },
    },

    created() {
      this.$http
        .get("/points")
        .then((response) => {
          this.updatePointBalance(response.data.points);
        })
        .catch(() => {
          console.log("failed to retrieve points");
        });
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Points/PointsOverview.vue